<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">新增</a-button>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        bordered
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        @change="handleTableChange"
      >
        <template slot="status" slot-scope="text">
          <span v-if="text == 0">未发布</span>
          <span v-if="text == 1">已发布</span>
          <span v-if="text == 2">已结束</span>
          <span v-if="text == 3">已删除</span>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />

          <a-popconfirm
            title="确定发布吗?"
            @confirm="() => handlePublish(record)"
            v-if="record.status == 0"
          >
            <a>发布</a>
          </a-popconfirm>
          <a-popconfirm
            title="确定撤回吗?"
            @confirm="() => handlePublish(record)"
            v-else-if="record.status == 1"
          >
            <a>撤回</a>
          </a-popconfirm>

          <a-divider type="vertical" />
          <a @click="lookData(record)">查看数据</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => handleDelete(record.id)"
          >
            <a>删除</a>
          </a-popconfirm>
        </span>

        <template slot="link" slot-scope="text">
          <a :href="pcUrl + 'questionnaire?id=' + text">
            {{ pcUrl + 'questionnaire?id=' + text }}
          </a>
        </template>
      </a-table>
    </div>

    <question-modal ref="modalForm" @ok="modalFormOk"></question-modal>

    <a-modal
      title="查看数据"
      :visible="showModal"
      width="880px"
      @ok="handleOk"
      @cancel="showModal = false"
    >
      <a-form-model :model="detail" ref="detail">
        <a-form-model-item style="text-align: center">
          <span style="font-weight: 600;font-size: 16px">{{
            detail.name
          }}</span>
        </a-form-model-item>
        <div
          class="item-form"
          v-for="(domain, index) in detail.listQuestionOptionDto"
          :key="index"
        >
          <a-row type="flex">
            <a-col :span="2">
              <p style="font-size: 16px;">Q{{ index + 1 }}</p>
            </a-col>
            <a-col :span="10">
              <p style="padding:0 12px;font-weight: 600;">
                {{ domain.questionName }}
              </p>
              <a-form-model-item>
                <div
                  v-for="(item, indexInner) in domain.questionOption"
                  :key="indexInner"
                >
                  <span style="padding:0 12px">{{ item }}</span>
                </div>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <div
                :style="
                  'width: 350px;height: ' +
                    (domain.questionType == '3' ? 100 : 270) +
                    'px;'
                "
                :id="'myChart' + index"
              ></div>
            </a-col>
          </a-row>
        </div>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { deletepaper } from '@/api/api';
import questionModal from './modules/questionModal';
import { mixinDevice } from '@/utils/mixin';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';

const columns = [
  {
    dataIndex: 'name',
    key: 'name',
    title: '问卷题目',
    width: '10%',
    align: 'center'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: '8%',
    align: 'center',
    scopedSlots: {
      customRender: 'status'
    }
  },
  {
    title: '链接',
    dataIndex: 'id',
    key: 'id',
    align: 'center',
    scopedSlots: {
      customRender: 'link'
    }
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    key: 'updateTime',
    align: 'center'
  },
  {
    title: '截止时间',
    dataIndex: 'endTime',
    key: 'endTime',
    align: 'center'
  },

  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    // fixed:"right",
    width: 220,
    scopedSlots: {
      customRender: 'action'
    }
  }
];
export default {
  name: 'quesitonManage',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    questionModal
  },
  data() {
    return {
      questionnaireQryDtoAllDTO: {
        id: null,
        name: '问卷名称',
        Questionstatus: null
      },
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/questions/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/contNotice/delete',
        detail: process.env.VUE_APP_CMS_CONTENT + '/cont/questions/selectpaper',
        paperData:
          process.env.VUE_APP_CMS_CONTENT + '/cont/questions/paper-data',
        publish: process.env.VUE_APP_CMS_CONTENT + '/cont/questions/publish'
      },
      columns,
      showModal: false,
      detail: {
        name: '问卷题目',
        listQuestionOptionDto: [],
        endtime: null
      },
      pcUrl: process.env.VUE_APP_PC_URL || ''
    };
  },

  methods: {
    drawLine(index, data) {
      // 基于准备好的dom，初始化echarts实例
      console.log(index);
      setTimeout(() => {
        let myChart = this.$echarts.init(
          document.getElementById(`myChart${index}`)
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: '数据占比',
            textStyle: {
              fontSize: 14,
              color: '#8E8E8E',
              align: 'left'
            }
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['2011年', '2012年']
          },
          grid: {
            left: '3%',
            right: '4%',
            top: '40px',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisTick: {
              //刻度线
              show: false
            },
            axisLabel: {
              color: '#8E8E8E'
            },
            axisLine: {
              //x轴
              lineStyle: {
                color: '#EFEFEF',
                width: 1 //这里是为了突出显示加上的
              }
            }
          },
          yAxis: {
            type: 'category',
            data: ['选项一', '选项二', '选项三', '选项四'],
            axisLabel: {
              color: '#8E8E8E'
              // formatter: '{value}%'
            },
            axisTick: {
              //刻度线
              show: false,
              alignWithLabel: false
            },
            axisLine: {
              //y轴
              show: false
            }
          },
          series: [
            {
              type: 'bar',
              barWidth: '50%',
              data,
              itemStyle: {
                barBorderColor: '#73c0de',
                color: '#73c0de'
              }
            }
          ]
        });
      }, 1000);
    },
    handleOk() {},
    lookData(records) {
      console.log(records);
      this.$http
        .get(
          this.url.paperData,
          {
            params: {
              id: records.id
            }
          },
          { headers: { 'Content-Type': 'application/json; charset=utf-8' } }
        )
        .then(res => {
          if (res.success) {
            let { result } = res;
            this.detail.name = result.name;
            let listQuestionOptionDto = result.questions;
            listQuestionOptionDto.forEach((item, index) => {
              // item.questionOption = item.questionOption
              this.drawLine(index, item.answerContent);
            });
            this.detail.listQuestionOptionDto = listQuestionOptionDto;
            this.detail.endtime = result.endtime
              ? moment(record.endtime, 'YYYY-MM-DD HH:mm:ss')
              : null;
          } else {
            this.$message.warning(res.message);
          }
        });

      // this.$http.get(this.url.paperData, {
      //   params : {
      //     id: records.id
      //   }
      // }, {headers:{'Content-Type':'application/json; charset=utf-8'}}).then(res => {
      //   if (res.success) {
      //     let { result } = res;
      //     console.log(result)
      //   }else{
      //     this.$message.warning(res.message)
      //   }
      // })
      this.showModal = true;
    },

    handlePublish(record) {
      console.log(record);
      if (record.status == 1) {
        record.status = '0';
      } else {
        record.status = '1';
      }
      let id = record.id;
      let name = record.name;
      let status = record.status;

      let params = {
        id,
        name,
        status
      };

      this.$http
        .post(this.url.publish, params, {
          headers: { 'Content-Type': 'application/json; charset=utf-8' }
        })
        .then(res => {
          if (res.success) {
            let { result } = res;
            console.log(result);
          } else {
            this.$message.warning(res.message);
          }
        });
      /*  this.$http.post(httpurl, params, {headers:{'Content-Type':'application/json; charset=utf-8'}}).then(res => {
            if (res.success) {
              this.$message.success(res.message)
              that.$emit('ok');
            }else{
              this.$message.warning(res.message)
            }*/

      /* postAction(this.url.publish,  this.questionnaireQryDto).then(res => {
          if (res.success) {
            this.$message.success('操作成功')

            this.loadData()

          }
        })
*/
    },

    handleDelete(id) {
      console.log(id);
      deletepaper({
        id: id
      }).then(res => {
        console.log(res);
        this.loadData();
      });
    }
  }
};
</script>

<style scoped lang="less">
.toolbar {
  width: 100%;
  text-align: center;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}

.ant-radio-group {
  display: flex;
  flex-direction: column;
}

.group-lable {
  display: block;
}
.item-form {
  padding: 20px;
  border-radius: 5px;
  border: 1px solid #eaeaea;
}
</style>
